import React from "react";
import ReactModal from 'react-modal'
import styled from "styled-components"
import BackgroundImage from 'gatsby-background-image'

ReactModal.setAppElement('body')

const HeroDiv = styled(BackgroundImage)`
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position: center bottom;
    height: 600px;
    margin-top: 80px;

    @media only screen and (max-width: 1140px) {
        margin-top: 80px;
        height: 570px;
    }

    @media only screen and (max-width: 767px) {
        margin-top: 80px;
        height: 780px
    }

    &.short {
        height: 240px;
        margin-top: 80px;
    
        @media only screen and (max-width: 767px) {
            height: 190px
        }

        .hero-flex {
            margin: 81px auto 0px;
        }
    
    }

    &.small-mobile {
        @media only screen and (max-width: 767px) {
            height: 200px
        }
    }
`;

const Flex = styled.div `
    max-width: 1110px;
    margin: 118px auto 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: start;

    @media only screen and (max-width: 1140px) {
        margin: 46px 30px;
        align-items: center;

        h1 {
            font-size: 40px;
            line-height: 44px;
        }
    }

    @media only screen and (max-width: 767px) {
       flex-direction: column-reverse;
       align-items: center;
    }
`;


const HeroTextDiv = styled.div `
    width: 52%;

    @media only screen and (max-width: 767px) {
        width: 100%;
    }

    p.hero {
        max-width: 85%;
        @media only screen and (max-width: 1140px) {
            max-width: 100%;
            line-height: 26px;
        }
    }
`;

const HeroImageDiv = styled.div `
    width: 48%;

    @media only screen and (max-width: 767px) {
        width: 100%;
        max-width 324px;
    }
`;

const HeroContentDiv = styled.img`
    position: relative;
    overflow: hidden;
    width: 590px;
    height: auto;
    float: right;
    margin-top: -70px;
    margin-right: 10px;

    @media only screen and (max-width: 1140px) {
        width: 100%;
        height: auto;
        margin-top: 0px;
    }

    @media only screen and (max-width: 767px) {
        max-width 324px;
        float: none;
    }
`;

const ModalDiv = styled.div `
    overflow: auto;
    @media only screen and (max-width: 600px) {
        max-height: 300px;
    }
`
const CloseModalLink = styled.a `
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
`

const VideoIFrame = styled.iframe `
    position: relative;
    overflow: hidden;
    width: 100%;
    margin-bottom: 0;
    border: 0;

    &.margin-top-40{
        width: 100%;
        height: 100%!important;
        min-height: 400px;
    }

    @media only screen and (max-width: 1140px) {
        width: 100%;
        height: 280px!important;
        min-height: 280px;

        &.margin-top-40{
            min-height: 200px!important;
        }
    }

`;

const closeSVG = () => (
    <svg width="27px" height="28px" viewBox="0 0 27 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
            <g id="ABOUT-/-Profile-Card" transform="translate(-506.000000, -19.000000)" stroke="#3D7BB2" stroke-width="3">
                <g id="Group" transform="translate(506.894034, 21.000000)">
                    <path d="M1,0.5 L23.7184681,23.2184681" id="Line-3"></path>
                    <path d="M1,0.5 L23.7184681,23.2184681" id="Line-3-Copy" transform="translate(12.500000, 12.000000) rotate(88.000000) translate(-12.500000, -12.000000) "></path>
                </g>
            </g>
        </g>
    </svg>
)

function createMarkup(data) { return {__html: data}; };

class HeroBase extends React.Component {
    constructor(props) {
        super();
        this.state = {
            isModalOpen: false
        };

      }
      handleModalOpen = event => {
        event.preventDefault();
        this.setState({ isModalOpen: true })
      }

      handleModalClose = event => {
        event.preventDefault();
        this.setState({ isModalOpen: false })
      }
      render() {
        return (
           <>
            <HeroDiv fluid={this.props.hero.background_image.asset.fluid} className={this.props.hero.background_color + " " + this.props.size + " " + this.props.mobileHero}>
                        <Flex className="hero-flex">
                        <HeroTextDiv className="hero">
                            <div dangerouslySetInnerHTML={createMarkup(this.props.hero.heading)}/>
                            <p className="hero text-white margin-top-20">{this.props.hero.subline}</p>

                            <a id="openModal" rel="nofollow" style={this.props.hero.video_url ? {} : { display: 'none' }} onClick={this.handleModalOpen} href={this.props.hero.video_url + '?video' }>Watch Demo Video</a>
                        </HeroTextDiv>
                        <HeroImageDiv>

                        { this.props.hero.image != null && 
                        <>
                        <HeroContentDiv src={this.props.hero.image.asset.url}></HeroContentDiv>
                        </>
                        }

                        </HeroImageDiv>
                        </Flex>
                    </HeroDiv>

                    <ReactModal isOpen={this.state.isModalOpen}
                        className="Modal video"
                        overlayClassName="Overlay"
                        shouldCloseOnOverlayClick={true}
                        onRequestClose={() => {
                            this.setState({ isModalOpen: false });
                        }} >
                    <ModalDiv> 
                        <VideoIFrame src={this.props.hero.video_url} className="videoIframe margin-top-40" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                    </ModalDiv>
                    <CloseModalLink onClick={this.handleModalClose}>
                        {closeSVG()}
                    </CloseModalLink>
                </ReactModal>
            </>
        )
      }
}

export default HeroBase